// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/settings/v1/admin_settings.proto" (package "c1.api.settings.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Duration } from "../../../../google/protobuf/duration";
import { Status } from "../../../../google/rpc/status";
import { FieldMask } from "../../../../google/protobuf/field_mask";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message c1.api.settings.v1.GetAWSExternalIDRequest
 */
export interface GetAWSExternalIDRequest {
}
/**
 * @generated from protobuf message c1.api.settings.v1.GetAWSExternalIDResponse
 */
export interface GetAWSExternalIDResponse {
    /**
     * @generated from protobuf field: c1.api.settings.v1.AWSExternalID aws_external_id = 1
     */
    awsExternalId?: AWSExternalID;
}
/**
 * @generated from protobuf message c1.api.settings.v1.DailyDigestSetting
 */
export interface DailyDigestSetting {
    /**
     * @generated from protobuf field: bool send_digest = 1
     */
    sendDigest: boolean;
    /**
     * @generated from protobuf field: bool digest_frequency_daily = 2
     */
    digestFrequencyDaily: boolean;
    /**
     * @generated from protobuf field: bool digest_frequency_tuesdays = 3
     */
    digestFrequencyTuesdays: boolean;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 4
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 5
     */
    updatedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.settings.v1.GetDailyDigestRequest
 */
export interface GetDailyDigestRequest {
}
/**
 * @generated from protobuf message c1.api.settings.v1.CreateDailyDigestRequest
 */
export interface CreateDailyDigestRequest {
    /**
     * @generated from protobuf field: c1.api.settings.v1.DailyDigestSetting daily_digest_setting = 1
     */
    dailyDigestSetting?: DailyDigestSetting;
}
/**
 * @generated from protobuf message c1.api.settings.v1.UpdateDailyDigestRequest
 */
export interface UpdateDailyDigestRequest {
    /**
     * @generated from protobuf field: c1.api.settings.v1.DailyDigestSetting daily_digest_setting = 1
     */
    dailyDigestSetting?: DailyDigestSetting;
    /**
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2
     */
    updateMask?: FieldMask;
}
/**
 * @generated from protobuf message c1.api.settings.v1.TestSourceIPRequest
 */
export interface TestSourceIPRequest {
    /**
     * if unset, uses the source IP of the request
     *
     * @generated from protobuf field: string source_ip = 1
     */
    sourceIp: string;
    /**
     * @generated from protobuf field: repeated string allow_cidr = 2
     */
    allowCidr: string[];
}
/**
 * @generated from protobuf message c1.api.settings.v1.TestSourceIPResponse
 */
export interface TestSourceIPResponse {
    /**
     * @generated from protobuf field: bool allowed = 1
     */
    allowed: boolean;
    /**
     * @generated from protobuf field: google.rpc.Status details = 2
     */
    details?: Status;
    /**
     * @generated from protobuf field: string checked_ip = 3
     */
    checkedIp: string;
}
/**
 * @generated from protobuf message c1.api.settings.v1.AWSExternalID
 */
export interface AWSExternalID {
    /**
     * @generated from protobuf field: string external_id = 1
     */
    externalId: string;
}
/**
 * @generated from protobuf message c1.api.settings.v1.CIDRRestriction
 */
export interface CIDRRestriction {
    /**
     * @generated from protobuf field: bool enabled = 1
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: repeated string source_cidr = 2
     */
    sourceCidr: string[];
}
/**
 * @generated from protobuf message c1.api.settings.v1.SessionSettings
 */
export interface SessionSettings {
    /**
     * @generated from protobuf field: google.protobuf.Duration max_session_length = 1
     */
    maxSessionLength?: Duration;
    /**
     * @generated from protobuf field: c1.api.settings.v1.CIDRRestriction sso_admin_source = 2
     */
    ssoAdminSource?: CIDRRestriction;
    /**
     * @generated from protobuf field: c1.api.settings.v1.CIDRRestriction sso_user_source = 3
     */
    ssoUserSource?: CIDRRestriction;
    /**
     * @generated from protobuf field: c1.api.settings.v1.CIDRRestriction pcc_admin_source = 4
     */
    pccAdminSource?: CIDRRestriction;
    /**
     * @generated from protobuf field: c1.api.settings.v1.CIDRRestriction pcc_user_source = 5
     */
    pccUserSource?: CIDRRestriction;
    /**
     * @generated from protobuf field: c1.api.settings.v1.CIDRRestriction connector_source = 6
     */
    connectorSource?: CIDRRestriction;
    /**
     * IP allowlist for external clients (DCR/MCP)
     *
     * @generated from protobuf field: c1.api.settings.v1.CIDRRestriction external_client_source = 7
     */
    externalClientSource?: CIDRRestriction;
    /**
     * Enable external client registration (OAuth 2.0 DCR) for MCP clients
     * like Claude Desktop, Cursor, and other AI assistants.
     *
     * @generated from protobuf field: bool external_clients_enabled = 8
     */
    externalClientsEnabled: boolean;
}
/**
 * @generated from protobuf message c1.api.settings.v1.GetSessionSettingsRequest
 */
export interface GetSessionSettingsRequest {
}
/**
 * @generated from protobuf message c1.api.settings.v1.GetSessionSettingsResponse
 */
export interface GetSessionSettingsResponse {
    /**
     * @generated from protobuf field: c1.api.settings.v1.SessionSettings session_settings = 1
     */
    sessionSettings?: SessionSettings;
}
/**
 * @generated from protobuf message c1.api.settings.v1.UpdateSessionSettingsRequest
 */
export interface UpdateSessionSettingsRequest {
    /**
     * @generated from protobuf field: c1.api.settings.v1.SessionSettings session_settings = 1
     */
    sessionSettings?: SessionSettings;
    /**
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2
     */
    updateMask?: FieldMask;
}
/**
 * @generated from protobuf message c1.api.settings.v1.UpdateSessionSettingsResponse
 */
export interface UpdateSessionSettingsResponse {
    /**
     * @generated from protobuf field: c1.api.settings.v1.SessionSettings session_settings = 1
     */
    sessionSettings?: SessionSettings;
}
/**
 * @generated from protobuf message c1.api.settings.v1.OrgDomain
 */
export interface OrgDomain {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string domain = 2
     */
    domain: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 5
     */
    deletedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.settings.v1.ListOrgDomainsRequest
 */
export interface ListOrgDomainsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.settings.v1.ListOrgDomainsResponse
 */
export interface ListOrgDomainsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.settings.v1.OrgDomain list = 1
     */
    list: OrgDomain[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.settings.v1.UpdateOrgDomainRequest
 */
export interface UpdateOrgDomainRequest {
    /**
     * @generated from protobuf field: repeated string new_domains = 1
     */
    newDomains: string[];
}
/**
 * @generated from protobuf message c1.api.settings.v1.UpdateOrgDomainResponse
 */
export interface UpdateOrgDomainResponse {
    /**
     * @generated from protobuf field: repeated c1.api.settings.v1.OrgDomain list = 1
     */
    list: OrgDomain[];
}
/**
 * @generated from protobuf message c1.api.settings.v1.NotificationConfig
 */
export interface NotificationConfig {
    /**
     * @generated from protobuf field: bool disable_email_notifications = 1
     */
    disableEmailNotifications: boolean;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 10
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 11
     */
    updatedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.settings.v1.GetNotificationConfigRequest
 */
export interface GetNotificationConfigRequest {
}
/**
 * @generated from protobuf message c1.api.settings.v1.GetNotificationConfigResponse
 */
export interface GetNotificationConfigResponse {
    /**
     * @generated from protobuf field: c1.api.settings.v1.NotificationConfig notification_config = 1
     */
    notificationConfig?: NotificationConfig;
}
/**
 * @generated from protobuf message c1.api.settings.v1.UpdateNotificationConfigRequest
 */
export interface UpdateNotificationConfigRequest {
    /**
     * @generated from protobuf field: c1.api.settings.v1.NotificationConfig notification_config = 1
     */
    notificationConfig?: NotificationConfig;
    /**
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2
     */
    updateMask?: FieldMask;
}
/**
 * @generated from protobuf message c1.api.settings.v1.UpdateNotificationConfigResponse
 */
export interface UpdateNotificationConfigResponse {
    /**
     * @generated from protobuf field: c1.api.settings.v1.NotificationConfig notification_config = 1
     */
    notificationConfig?: NotificationConfig;
}
// @generated message type with reflection information, may provide speed optimized methods
class GetAWSExternalIDRequest$Type extends MessageType<GetAWSExternalIDRequest> {
    constructor() {
        super("c1.api.settings.v1.GetAWSExternalIDRequest", [], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "AWS_EXTERNAL_ID" } }] } });
    }
    create(value?: PartialMessage<GetAWSExternalIDRequest>): GetAWSExternalIDRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetAWSExternalIDRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAWSExternalIDRequest): GetAWSExternalIDRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAWSExternalIDRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.GetAWSExternalIDRequest
 */
export const GetAWSExternalIDRequest = new GetAWSExternalIDRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAWSExternalIDResponse$Type extends MessageType<GetAWSExternalIDResponse> {
    constructor() {
        super("c1.api.settings.v1.GetAWSExternalIDResponse", [
            { no: 1, name: "aws_external_id", kind: "message", T: () => AWSExternalID }
        ]);
    }
    create(value?: PartialMessage<GetAWSExternalIDResponse>): GetAWSExternalIDResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetAWSExternalIDResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAWSExternalIDResponse): GetAWSExternalIDResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.settings.v1.AWSExternalID aws_external_id */ 1:
                    message.awsExternalId = AWSExternalID.internalBinaryRead(reader, reader.uint32(), options, message.awsExternalId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAWSExternalIDResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.settings.v1.AWSExternalID aws_external_id = 1; */
        if (message.awsExternalId)
            AWSExternalID.internalBinaryWrite(message.awsExternalId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.GetAWSExternalIDResponse
 */
export const GetAWSExternalIDResponse = new GetAWSExternalIDResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DailyDigestSetting$Type extends MessageType<DailyDigestSetting> {
    constructor() {
        super("c1.api.settings.v1.DailyDigestSetting", [
            { no: 1, name: "send_digest", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "digest_frequency_daily", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "digest_frequency_tuesdays", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
    create(value?: PartialMessage<DailyDigestSetting>): DailyDigestSetting {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sendDigest = false;
        message.digestFrequencyDaily = false;
        message.digestFrequencyTuesdays = false;
        if (value !== undefined)
            reflectionMergePartial<DailyDigestSetting>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DailyDigestSetting): DailyDigestSetting {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool send_digest */ 1:
                    message.sendDigest = reader.bool();
                    break;
                case /* bool digest_frequency_daily */ 2:
                    message.digestFrequencyDaily = reader.bool();
                    break;
                case /* bool digest_frequency_tuesdays */ 3:
                    message.digestFrequencyTuesdays = reader.bool();
                    break;
                case /* google.protobuf.Timestamp created_at */ 4:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 5:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DailyDigestSetting, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool send_digest = 1; */
        if (message.sendDigest !== false)
            writer.tag(1, WireType.Varint).bool(message.sendDigest);
        /* bool digest_frequency_daily = 2; */
        if (message.digestFrequencyDaily !== false)
            writer.tag(2, WireType.Varint).bool(message.digestFrequencyDaily);
        /* bool digest_frequency_tuesdays = 3; */
        if (message.digestFrequencyTuesdays !== false)
            writer.tag(3, WireType.Varint).bool(message.digestFrequencyTuesdays);
        /* google.protobuf.Timestamp created_at = 4; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 5; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.DailyDigestSetting
 */
export const DailyDigestSetting = new DailyDigestSetting$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDailyDigestRequest$Type extends MessageType<GetDailyDigestRequest> {
    constructor() {
        super("c1.api.settings.v1.GetDailyDigestRequest", []);
    }
    create(value?: PartialMessage<GetDailyDigestRequest>): GetDailyDigestRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetDailyDigestRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetDailyDigestRequest): GetDailyDigestRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetDailyDigestRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.GetDailyDigestRequest
 */
export const GetDailyDigestRequest = new GetDailyDigestRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateDailyDigestRequest$Type extends MessageType<CreateDailyDigestRequest> {
    constructor() {
        super("c1.api.settings.v1.CreateDailyDigestRequest", [
            { no: 1, name: "daily_digest_setting", kind: "message", T: () => DailyDigestSetting }
        ]);
    }
    create(value?: PartialMessage<CreateDailyDigestRequest>): CreateDailyDigestRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreateDailyDigestRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateDailyDigestRequest): CreateDailyDigestRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.settings.v1.DailyDigestSetting daily_digest_setting */ 1:
                    message.dailyDigestSetting = DailyDigestSetting.internalBinaryRead(reader, reader.uint32(), options, message.dailyDigestSetting);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateDailyDigestRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.settings.v1.DailyDigestSetting daily_digest_setting = 1; */
        if (message.dailyDigestSetting)
            DailyDigestSetting.internalBinaryWrite(message.dailyDigestSetting, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.CreateDailyDigestRequest
 */
export const CreateDailyDigestRequest = new CreateDailyDigestRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDailyDigestRequest$Type extends MessageType<UpdateDailyDigestRequest> {
    constructor() {
        super("c1.api.settings.v1.UpdateDailyDigestRequest", [
            { no: 1, name: "daily_digest_setting", kind: "message", T: () => DailyDigestSetting, options: { "validate.rules": { message: { skip: true } } } },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
    create(value?: PartialMessage<UpdateDailyDigestRequest>): UpdateDailyDigestRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateDailyDigestRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateDailyDigestRequest): UpdateDailyDigestRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.settings.v1.DailyDigestSetting daily_digest_setting */ 1:
                    message.dailyDigestSetting = DailyDigestSetting.internalBinaryRead(reader, reader.uint32(), options, message.dailyDigestSetting);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 2:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateDailyDigestRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.settings.v1.DailyDigestSetting daily_digest_setting = 1; */
        if (message.dailyDigestSetting)
            DailyDigestSetting.internalBinaryWrite(message.dailyDigestSetting, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 2; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.UpdateDailyDigestRequest
 */
export const UpdateDailyDigestRequest = new UpdateDailyDigestRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TestSourceIPRequest$Type extends MessageType<TestSourceIPRequest> {
    constructor() {
        super("c1.api.settings.v1.TestSourceIPRequest", [
            { no: 1, name: "source_ip", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^([0-9]{1,3}\\.){3}[0-9]{1,3}(\\/([0-9]|[1-2][0-9]|3[0-2]))?$", ignoreEmpty: true } } } },
            { no: 2, name: "allow_cidr", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^([0-9]{1,3}\\.){3}[0-9]{1,3}(\\/([0-9]|[1-2][0-9]|3[0-2]))?$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<TestSourceIPRequest>): TestSourceIPRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sourceIp = "";
        message.allowCidr = [];
        if (value !== undefined)
            reflectionMergePartial<TestSourceIPRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TestSourceIPRequest): TestSourceIPRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string source_ip */ 1:
                    message.sourceIp = reader.string();
                    break;
                case /* repeated string allow_cidr */ 2:
                    message.allowCidr.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TestSourceIPRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string source_ip = 1; */
        if (message.sourceIp !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sourceIp);
        /* repeated string allow_cidr = 2; */
        for (let i = 0; i < message.allowCidr.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.allowCidr[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.TestSourceIPRequest
 */
export const TestSourceIPRequest = new TestSourceIPRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TestSourceIPResponse$Type extends MessageType<TestSourceIPResponse> {
    constructor() {
        super("c1.api.settings.v1.TestSourceIPResponse", [
            { no: 1, name: "allowed", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "details", kind: "message", T: () => Status },
            { no: 3, name: "checked_ip", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TestSourceIPResponse>): TestSourceIPResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.allowed = false;
        message.checkedIp = "";
        if (value !== undefined)
            reflectionMergePartial<TestSourceIPResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TestSourceIPResponse): TestSourceIPResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool allowed */ 1:
                    message.allowed = reader.bool();
                    break;
                case /* google.rpc.Status details */ 2:
                    message.details = Status.internalBinaryRead(reader, reader.uint32(), options, message.details);
                    break;
                case /* string checked_ip */ 3:
                    message.checkedIp = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TestSourceIPResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool allowed = 1; */
        if (message.allowed !== false)
            writer.tag(1, WireType.Varint).bool(message.allowed);
        /* google.rpc.Status details = 2; */
        if (message.details)
            Status.internalBinaryWrite(message.details, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string checked_ip = 3; */
        if (message.checkedIp !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.checkedIp);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.TestSourceIPResponse
 */
export const TestSourceIPResponse = new TestSourceIPResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AWSExternalID$Type extends MessageType<AWSExternalID> {
    constructor() {
        super("c1.api.settings.v1.AWSExternalID", [
            { no: 1, name: "external_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "AWS_EXTERNAL_ID" } }] } });
    }
    create(value?: PartialMessage<AWSExternalID>): AWSExternalID {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.externalId = "";
        if (value !== undefined)
            reflectionMergePartial<AWSExternalID>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AWSExternalID): AWSExternalID {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string external_id */ 1:
                    message.externalId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AWSExternalID, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string external_id = 1; */
        if (message.externalId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.externalId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.AWSExternalID
 */
export const AWSExternalID = new AWSExternalID$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CIDRRestriction$Type extends MessageType<CIDRRestriction> {
    constructor() {
        super("c1.api.settings.v1.CIDRRestriction", [
            { no: 1, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "source_cidr", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^([0-9]{1,3}\\.){3}[0-9]{1,3}(\\/([0-9]|[1-2][0-9]|3[0-2]))?$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<CIDRRestriction>): CIDRRestriction {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.enabled = false;
        message.sourceCidr = [];
        if (value !== undefined)
            reflectionMergePartial<CIDRRestriction>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CIDRRestriction): CIDRRestriction {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool enabled */ 1:
                    message.enabled = reader.bool();
                    break;
                case /* repeated string source_cidr */ 2:
                    message.sourceCidr.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CIDRRestriction, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool enabled = 1; */
        if (message.enabled !== false)
            writer.tag(1, WireType.Varint).bool(message.enabled);
        /* repeated string source_cidr = 2; */
        for (let i = 0; i < message.sourceCidr.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.sourceCidr[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.CIDRRestriction
 */
export const CIDRRestriction = new CIDRRestriction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SessionSettings$Type extends MessageType<SessionSettings> {
    constructor() {
        super("c1.api.settings.v1.SessionSettings", [
            { no: 1, name: "max_session_length", kind: "message", T: () => Duration, options: { "validate.rules": { duration: { in: [{ seconds: "2700" }, { seconds: "3600" }, { seconds: "7200" }, { seconds: "14400" }, { seconds: "28800" }, { seconds: "57600" }, { seconds: "72000" }] } } } },
            { no: 2, name: "sso_admin_source", kind: "message", T: () => CIDRRestriction },
            { no: 3, name: "sso_user_source", kind: "message", T: () => CIDRRestriction },
            { no: 4, name: "pcc_admin_source", kind: "message", T: () => CIDRRestriction },
            { no: 5, name: "pcc_user_source", kind: "message", T: () => CIDRRestriction },
            { no: 6, name: "connector_source", kind: "message", T: () => CIDRRestriction },
            { no: 7, name: "external_client_source", kind: "message", T: () => CIDRRestriction },
            { no: 8, name: "external_clients_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<SessionSettings>): SessionSettings {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.externalClientsEnabled = false;
        if (value !== undefined)
            reflectionMergePartial<SessionSettings>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SessionSettings): SessionSettings {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Duration max_session_length */ 1:
                    message.maxSessionLength = Duration.internalBinaryRead(reader, reader.uint32(), options, message.maxSessionLength);
                    break;
                case /* c1.api.settings.v1.CIDRRestriction sso_admin_source */ 2:
                    message.ssoAdminSource = CIDRRestriction.internalBinaryRead(reader, reader.uint32(), options, message.ssoAdminSource);
                    break;
                case /* c1.api.settings.v1.CIDRRestriction sso_user_source */ 3:
                    message.ssoUserSource = CIDRRestriction.internalBinaryRead(reader, reader.uint32(), options, message.ssoUserSource);
                    break;
                case /* c1.api.settings.v1.CIDRRestriction pcc_admin_source */ 4:
                    message.pccAdminSource = CIDRRestriction.internalBinaryRead(reader, reader.uint32(), options, message.pccAdminSource);
                    break;
                case /* c1.api.settings.v1.CIDRRestriction pcc_user_source */ 5:
                    message.pccUserSource = CIDRRestriction.internalBinaryRead(reader, reader.uint32(), options, message.pccUserSource);
                    break;
                case /* c1.api.settings.v1.CIDRRestriction connector_source */ 6:
                    message.connectorSource = CIDRRestriction.internalBinaryRead(reader, reader.uint32(), options, message.connectorSource);
                    break;
                case /* c1.api.settings.v1.CIDRRestriction external_client_source */ 7:
                    message.externalClientSource = CIDRRestriction.internalBinaryRead(reader, reader.uint32(), options, message.externalClientSource);
                    break;
                case /* bool external_clients_enabled */ 8:
                    message.externalClientsEnabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SessionSettings, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Duration max_session_length = 1; */
        if (message.maxSessionLength)
            Duration.internalBinaryWrite(message.maxSessionLength, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.settings.v1.CIDRRestriction sso_admin_source = 2; */
        if (message.ssoAdminSource)
            CIDRRestriction.internalBinaryWrite(message.ssoAdminSource, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.settings.v1.CIDRRestriction sso_user_source = 3; */
        if (message.ssoUserSource)
            CIDRRestriction.internalBinaryWrite(message.ssoUserSource, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.settings.v1.CIDRRestriction pcc_admin_source = 4; */
        if (message.pccAdminSource)
            CIDRRestriction.internalBinaryWrite(message.pccAdminSource, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.settings.v1.CIDRRestriction pcc_user_source = 5; */
        if (message.pccUserSource)
            CIDRRestriction.internalBinaryWrite(message.pccUserSource, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.settings.v1.CIDRRestriction connector_source = 6; */
        if (message.connectorSource)
            CIDRRestriction.internalBinaryWrite(message.connectorSource, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.settings.v1.CIDRRestriction external_client_source = 7; */
        if (message.externalClientSource)
            CIDRRestriction.internalBinaryWrite(message.externalClientSource, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* bool external_clients_enabled = 8; */
        if (message.externalClientsEnabled !== false)
            writer.tag(8, WireType.Varint).bool(message.externalClientsEnabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.SessionSettings
 */
export const SessionSettings = new SessionSettings$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSessionSettingsRequest$Type extends MessageType<GetSessionSettingsRequest> {
    constructor() {
        super("c1.api.settings.v1.GetSessionSettingsRequest", []);
    }
    create(value?: PartialMessage<GetSessionSettingsRequest>): GetSessionSettingsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetSessionSettingsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSessionSettingsRequest): GetSessionSettingsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSessionSettingsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.GetSessionSettingsRequest
 */
export const GetSessionSettingsRequest = new GetSessionSettingsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSessionSettingsResponse$Type extends MessageType<GetSessionSettingsResponse> {
    constructor() {
        super("c1.api.settings.v1.GetSessionSettingsResponse", [
            { no: 1, name: "session_settings", kind: "message", T: () => SessionSettings }
        ]);
    }
    create(value?: PartialMessage<GetSessionSettingsResponse>): GetSessionSettingsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetSessionSettingsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSessionSettingsResponse): GetSessionSettingsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.settings.v1.SessionSettings session_settings */ 1:
                    message.sessionSettings = SessionSettings.internalBinaryRead(reader, reader.uint32(), options, message.sessionSettings);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSessionSettingsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.settings.v1.SessionSettings session_settings = 1; */
        if (message.sessionSettings)
            SessionSettings.internalBinaryWrite(message.sessionSettings, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.GetSessionSettingsResponse
 */
export const GetSessionSettingsResponse = new GetSessionSettingsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSessionSettingsRequest$Type extends MessageType<UpdateSessionSettingsRequest> {
    constructor() {
        super("c1.api.settings.v1.UpdateSessionSettingsRequest", [
            { no: 1, name: "session_settings", kind: "message", T: () => SessionSettings },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
    create(value?: PartialMessage<UpdateSessionSettingsRequest>): UpdateSessionSettingsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateSessionSettingsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateSessionSettingsRequest): UpdateSessionSettingsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.settings.v1.SessionSettings session_settings */ 1:
                    message.sessionSettings = SessionSettings.internalBinaryRead(reader, reader.uint32(), options, message.sessionSettings);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 2:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateSessionSettingsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.settings.v1.SessionSettings session_settings = 1; */
        if (message.sessionSettings)
            SessionSettings.internalBinaryWrite(message.sessionSettings, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 2; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.UpdateSessionSettingsRequest
 */
export const UpdateSessionSettingsRequest = new UpdateSessionSettingsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSessionSettingsResponse$Type extends MessageType<UpdateSessionSettingsResponse> {
    constructor() {
        super("c1.api.settings.v1.UpdateSessionSettingsResponse", [
            { no: 1, name: "session_settings", kind: "message", T: () => SessionSettings }
        ]);
    }
    create(value?: PartialMessage<UpdateSessionSettingsResponse>): UpdateSessionSettingsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateSessionSettingsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateSessionSettingsResponse): UpdateSessionSettingsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.settings.v1.SessionSettings session_settings */ 1:
                    message.sessionSettings = SessionSettings.internalBinaryRead(reader, reader.uint32(), options, message.sessionSettings);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateSessionSettingsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.settings.v1.SessionSettings session_settings = 1; */
        if (message.sessionSettings)
            SessionSettings.internalBinaryWrite(message.sessionSettings, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.UpdateSessionSettingsResponse
 */
export const UpdateSessionSettingsResponse = new UpdateSessionSettingsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrgDomain$Type extends MessageType<OrgDomain> {
    constructor() {
        super("c1.api.settings.v1.OrgDomain", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "domain", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024" } } } },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
    create(value?: PartialMessage<OrgDomain>): OrgDomain {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.domain = "";
        if (value !== undefined)
            reflectionMergePartial<OrgDomain>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OrgDomain): OrgDomain {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string domain */ 2:
                    message.domain = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 3:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 4:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 5:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OrgDomain, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string domain = 2; */
        if (message.domain !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.domain);
        /* google.protobuf.Timestamp created_at = 3; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 4; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 5; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.OrgDomain
 */
export const OrgDomain = new OrgDomain$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListOrgDomainsRequest$Type extends MessageType<ListOrgDomainsRequest> {
    constructor() {
        super("c1.api.settings.v1.ListOrgDomainsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<ListOrgDomainsRequest>): ListOrgDomainsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ListOrgDomainsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListOrgDomainsRequest): ListOrgDomainsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListOrgDomainsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.ListOrgDomainsRequest
 */
export const ListOrgDomainsRequest = new ListOrgDomainsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListOrgDomainsResponse$Type extends MessageType<ListOrgDomainsResponse> {
    constructor() {
        super("c1.api.settings.v1.ListOrgDomainsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => OrgDomain },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ListOrgDomainsResponse>): ListOrgDomainsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ListOrgDomainsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListOrgDomainsResponse): ListOrgDomainsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.settings.v1.OrgDomain list */ 1:
                    message.list.push(OrgDomain.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListOrgDomainsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.settings.v1.OrgDomain list = 1; */
        for (let i = 0; i < message.list.length; i++)
            OrgDomain.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.ListOrgDomainsResponse
 */
export const ListOrgDomainsResponse = new ListOrgDomainsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateOrgDomainRequest$Type extends MessageType<UpdateOrgDomainRequest> {
    constructor() {
        super("c1.api.settings.v1.UpdateOrgDomainRequest", [
            { no: 1, name: "new_domains", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateOrgDomainRequest>): UpdateOrgDomainRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.newDomains = [];
        if (value !== undefined)
            reflectionMergePartial<UpdateOrgDomainRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateOrgDomainRequest): UpdateOrgDomainRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string new_domains */ 1:
                    message.newDomains.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateOrgDomainRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string new_domains = 1; */
        for (let i = 0; i < message.newDomains.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.newDomains[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.UpdateOrgDomainRequest
 */
export const UpdateOrgDomainRequest = new UpdateOrgDomainRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateOrgDomainResponse$Type extends MessageType<UpdateOrgDomainResponse> {
    constructor() {
        super("c1.api.settings.v1.UpdateOrgDomainResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => OrgDomain }
        ]);
    }
    create(value?: PartialMessage<UpdateOrgDomainResponse>): UpdateOrgDomainResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        if (value !== undefined)
            reflectionMergePartial<UpdateOrgDomainResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateOrgDomainResponse): UpdateOrgDomainResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.settings.v1.OrgDomain list */ 1:
                    message.list.push(OrgDomain.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateOrgDomainResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.settings.v1.OrgDomain list = 1; */
        for (let i = 0; i < message.list.length; i++)
            OrgDomain.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.UpdateOrgDomainResponse
 */
export const UpdateOrgDomainResponse = new UpdateOrgDomainResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NotificationConfig$Type extends MessageType<NotificationConfig> {
    constructor() {
        super("c1.api.settings.v1.NotificationConfig", [
            { no: 1, name: "disable_email_notifications", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 11, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
    create(value?: PartialMessage<NotificationConfig>): NotificationConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.disableEmailNotifications = false;
        if (value !== undefined)
            reflectionMergePartial<NotificationConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: NotificationConfig): NotificationConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool disable_email_notifications */ 1:
                    message.disableEmailNotifications = reader.bool();
                    break;
                case /* google.protobuf.Timestamp created_at */ 10:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 11:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: NotificationConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool disable_email_notifications = 1; */
        if (message.disableEmailNotifications !== false)
            writer.tag(1, WireType.Varint).bool(message.disableEmailNotifications);
        /* google.protobuf.Timestamp created_at = 10; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 11; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.NotificationConfig
 */
export const NotificationConfig = new NotificationConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetNotificationConfigRequest$Type extends MessageType<GetNotificationConfigRequest> {
    constructor() {
        super("c1.api.settings.v1.GetNotificationConfigRequest", []);
    }
    create(value?: PartialMessage<GetNotificationConfigRequest>): GetNotificationConfigRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetNotificationConfigRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetNotificationConfigRequest): GetNotificationConfigRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetNotificationConfigRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.GetNotificationConfigRequest
 */
export const GetNotificationConfigRequest = new GetNotificationConfigRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetNotificationConfigResponse$Type extends MessageType<GetNotificationConfigResponse> {
    constructor() {
        super("c1.api.settings.v1.GetNotificationConfigResponse", [
            { no: 1, name: "notification_config", kind: "message", T: () => NotificationConfig }
        ]);
    }
    create(value?: PartialMessage<GetNotificationConfigResponse>): GetNotificationConfigResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetNotificationConfigResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetNotificationConfigResponse): GetNotificationConfigResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.settings.v1.NotificationConfig notification_config */ 1:
                    message.notificationConfig = NotificationConfig.internalBinaryRead(reader, reader.uint32(), options, message.notificationConfig);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetNotificationConfigResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.settings.v1.NotificationConfig notification_config = 1; */
        if (message.notificationConfig)
            NotificationConfig.internalBinaryWrite(message.notificationConfig, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.GetNotificationConfigResponse
 */
export const GetNotificationConfigResponse = new GetNotificationConfigResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateNotificationConfigRequest$Type extends MessageType<UpdateNotificationConfigRequest> {
    constructor() {
        super("c1.api.settings.v1.UpdateNotificationConfigRequest", [
            { no: 1, name: "notification_config", kind: "message", T: () => NotificationConfig, options: { "validate.rules": { message: { skip: true } } } },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
    create(value?: PartialMessage<UpdateNotificationConfigRequest>): UpdateNotificationConfigRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateNotificationConfigRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateNotificationConfigRequest): UpdateNotificationConfigRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.settings.v1.NotificationConfig notification_config */ 1:
                    message.notificationConfig = NotificationConfig.internalBinaryRead(reader, reader.uint32(), options, message.notificationConfig);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 2:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateNotificationConfigRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.settings.v1.NotificationConfig notification_config = 1; */
        if (message.notificationConfig)
            NotificationConfig.internalBinaryWrite(message.notificationConfig, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 2; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.UpdateNotificationConfigRequest
 */
export const UpdateNotificationConfigRequest = new UpdateNotificationConfigRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateNotificationConfigResponse$Type extends MessageType<UpdateNotificationConfigResponse> {
    constructor() {
        super("c1.api.settings.v1.UpdateNotificationConfigResponse", [
            { no: 1, name: "notification_config", kind: "message", T: () => NotificationConfig }
        ]);
    }
    create(value?: PartialMessage<UpdateNotificationConfigResponse>): UpdateNotificationConfigResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateNotificationConfigResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateNotificationConfigResponse): UpdateNotificationConfigResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.settings.v1.NotificationConfig notification_config */ 1:
                    message.notificationConfig = NotificationConfig.internalBinaryRead(reader, reader.uint32(), options, message.notificationConfig);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateNotificationConfigResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.settings.v1.NotificationConfig notification_config = 1; */
        if (message.notificationConfig)
            NotificationConfig.internalBinaryWrite(message.notificationConfig, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.UpdateNotificationConfigResponse
 */
export const UpdateNotificationConfigResponse = new UpdateNotificationConfigResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.settings.v1.AWSExternalIDSettings
 */
export const AWSExternalIDSettings = new ServiceType("c1.api.settings.v1.AWSExternalIDSettings", [
    { name: "Get", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/settings/aws-external-id", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "AWS_EXTERNAL_ID" }], group: "AWS External ID Settings" }] } }, I: GetAWSExternalIDRequest, O: GetAWSExternalIDResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.settings.v1.DailyDigestSettings
 */
export const DailyDigestSettings = new ServiceType("c1.api.settings.v1.DailyDigestSettings", [
    { name: "Get", options: { "authz.method": { role: "VIEWER" } }, I: GetDailyDigestRequest, O: DailyDigestSetting },
    { name: "Update", options: { "authz.method": { role: "EDITOR" } }, I: UpdateDailyDigestRequest, O: DailyDigestSetting }
]);
/**
 * @generated ServiceType for protobuf service c1.api.settings.v1.SessionSettingsService
 */
export const SessionSettingsService = new ServiceType("c1.api.settings.v1.SessionSettingsService", [
    { name: "Get", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/settings/session", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "SessionSettings", optionalExclusion: "OPTIONAL_EXCLUSION_RESOURCE_ONLY" }], group: "Session Settings" }] } }, I: GetSessionSettingsRequest, O: GetSessionSettingsResponse },
    { name: "Update", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/settings/session", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_UPDATE", name: "SessionSettings" }], group: "Session Settings" }] } }, I: UpdateSessionSettingsRequest, O: UpdateSessionSettingsResponse },
    { name: "TestSourceIP", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/settings/session/test-source-ip", group: "Session Settings" }] } }, I: TestSourceIPRequest, O: TestSourceIPResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.settings.v1.OrgDomainService
 */
export const OrgDomainService = new ServiceType("c1.api.settings.v1.OrgDomainService", [
    { name: "List", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/settings/domains", query: { page_size: "page_size", page_token: "page_token" }, terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "OrgDomains", optionalExclusion: "OPTIONAL_EXCLUSION_DATA_SOURCE_ONLY" }], group: "Org Domain", pagination: { type: "TERRAFORM_ENTITY_PAGINATION_TYPE_CURSOR", inputs: [{ name: "pageToken", type: "TERRAFORM_ENTITY_PAGINATION_INPUT_TYPE_CURSOR" }], outputs: { nextCursor: "$.nextPageToken" } } }] } }, I: ListOrgDomainsRequest, O: ListOrgDomainsResponse },
    { name: "Update", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "PUT", route: "/api/v1/settings/domains", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_UPDATE", name: "OrgDomains" }], group: "Org Domain" }] } }, I: UpdateOrgDomainRequest, O: UpdateOrgDomainResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.settings.v1.NotificationConfigService
 */
export const NotificationConfigService = new ServiceType("c1.api.settings.v1.NotificationConfigService", [
    { name: "Get", options: { "authz.method": { role: "VIEWER" } }, I: GetNotificationConfigRequest, O: GetNotificationConfigResponse },
    { name: "Update", options: { "authz.method": { role: "EDITOR" } }, I: UpdateNotificationConfigRequest, O: UpdateNotificationConfigResponse }
]);
